module.exports = __webpack_public_path__ + "static/5b1fbd62-45dc-4433-a7df-a2b24a146411-bc69d60c1fbeea60ca09d07b45a73740.woff2";